import React, { Component } from 'react'
import './footer.css'

export class footer extends Component {
  render() {
    return (
      <div className='main-footer'>
        <p className="footer-title">{process.env.REACT_APP_SETOR} &copy; {process.env.REACT_APP_ANO} {process.env.REACT_APP_DEFENSORIA}</p>
      </div>
    )
  }
}

export default footer



// WEBPACK FOOTER //
// ./src/components/footer/footer.jsx